import { createAsyncThunk } from '@reduxjs/toolkit';
import UserStockAlertsAPI from './userStockAlertsAPI';

export const createAlertThunk = createAsyncThunk(
  'alerts/create',
  async (alertData, { rejectWithValue }) => {
    try {
      return await UserStockAlertsAPI.create(alertData);
    } catch (error) {
      return rejectWithValue(error.message || 'Alert creation failed');
    }
  }
);

export const fetchUserAlertsThunk = createAsyncThunk(
  'alerts/fetchUser',
  async (userId, { rejectWithValue }) => {
    try {
      return await UserStockAlertsAPI.fetchByUser(userId);
    } catch (error) {
      return rejectWithValue(error.message || 'Fetching alerts failed');
    }
  }
);

export const updateAlertThunk = createAsyncThunk(
  'alerts/update',
  async ({ alertId, alertData }, { rejectWithValue }) => {
    try {
      return await UserStockAlertsAPI.update(alertId, alertData);
    } catch (error) {
      return rejectWithValue(error.message || 'Update failed');
    }
  }
);

export const deleteAlertThunk = createAsyncThunk(
  'alerts/delete',
  async (alertId, { rejectWithValue }) => {
    try {
      return await UserStockAlertsAPI.delete(alertId);
    } catch (error) {
      return rejectWithValue(error.message || 'Deletion failed');
    }
  }
);